module.exports = __webpack_public_path__ + "img/nave-02.5265928d.jpg";